export default __webpack_public_path__ + "static/media/data1.6ea9cb89.png";